import { makeStyles } from 'tss-react/mui';

const useRecoverPasswordPanelStyles = makeStyles()((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export default useRecoverPasswordPanelStyles;
